import React, {useEffect} from 'react';
import {ReactComponent as DragAudioIcon} from '../../../../../../../../assets/main/test/drag-audio.svg';
import {ReactComponent as InfoSmallerIcon} from '../../../../../../../../assets/main/test/info-smaller.svg';
import {ReactComponent as CloseIcon} from '../../../../../../../../assets/header/сlose.svg';
import {useInputWithFocus} from "common/hook/useInputWithFocus";
import TextArea from "antd/es/input/TextArea";
import {useFormik} from "formik";
import {useFileUpload} from "common/hook/use-file-upload";
import {useAppDispatch, useAppSelector} from "common/hook";
import {fetchSubmitHomework} from "features/model/service/submit-homework/fetchSubmitHomework";
import {useNavigate, useParams} from "react-router-dom";
import {message} from 'antd';
import {homeworkErrors, homeworkSuccess} from "features/model/slice/homework/homeworkResponseStudent";



export const ResponseTable = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const SubmitHomeworkStatus = useAppSelector((state) => state.responseStudentHomework);
    const {success,error} = SubmitHomeworkStatus


    const {groupId,lessonsId} = useParams();

    const {isFilled, handleFocus, handleBlur} = useInputWithFocus([false]);

    const successMessage = () => {
        message.success('Ответ успешно отправлен');
    };


    useEffect(() => {
        return () => {
            dispatch(homeworkErrors(null));
        };
    }, []);


    const {
        drag: drag1,
        fileNames: fileNames1,
        fileInputRef: fileInputRef1,
        handleFileUpload: handleFileUpload1,
        handleFileRemove: handleFileRemove1,
        handleFileChange: handleFileChange1,
        dragStartHandler: dragStartHandler1,
        dragLeaveHandler: dragLeaveHandler1,
        onDropHandler: onDropHandler1,
        uploadedFiles: uploadedFiles1,
    } = useFileUpload();

    const formik = useFormik({
        initialValues: {
            text: "",
        },
        onSubmit: (values) => {
        },
    });


    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const formData = new FormData();
        if (lessonsId !== undefined) {
            formData.append("lesson_id", lessonsId.toString());
        }
        formData.append("text", formik.values.text);

        if (uploadedFiles1.length > 0) {
            uploadedFiles1.forEach((file) => {
                formData.append(`files[]`, file);
            });
        }

        try {
            await dispatch(fetchSubmitHomework({ homeworkAnswerData: formData }));
        } catch (error) {

        }
    };

    useEffect(() => {
        if (success) {
            successMessage();
            dispatch(homeworkSuccess());
            navigate(`/groups/${groupId}/lessons/${lessonsId}`);
        }
    }, [success, lessonsId]);



    return (
        <div className="student-answer-box">
            <form className="form" onSubmit={handleSubmit}>
                <div className="fields-row">
                    <div
                        className={`field  ${isFilled[0] ? 'filled' : ''} ${error ? 'error-field' : ''}`}>
                        <label className={`field-name ${formik.values.text ? 'active-label' : ''}`}>Комментарий</label>
                        <div className="textarea-box">
                            <TextArea
                                className="form-control form-control-no-scroll"
                                id="text"
                                name="text"
                                value={formik.values.text}
                                onChange={formik.handleChange}
                                onFocus={() => handleFocus(0)}
                                onBlur={handleBlur}
                                autoSize={{minRows: 3, maxRows: 10}}
                            />
                        </div>
                        {error  && <p className="field-error">{error}</p>}
                    </div>
                </div>

                <div className="fields-row">
                    <div className="field">
                        {drag1 ?
                            <div
                                onDragStart={(e) => dragStartHandler1(e)}
                                onDragLeave={(e) => dragLeaveHandler1(e)}
                                onDragOver={(e) => dragStartHandler1(e)}
                                onDrop={(e) => onDropHandler1(e)}
                                onClick={handleFileUpload1}
                                className="upload-box upload-box-drop"
                            >
                                <p>Отпустите файл, чтобы загрузить его</p>
                            </div> :
                            <div className="upload-box">
                                <div
                                    onDragStart={(e) => dragStartHandler1(e)}
                                    onDragLeave={(e) => dragLeaveHandler1(e)}
                                    onDragOver={(e) => dragStartHandler1(e)}
                                    onDrop={(e) => onDropHandler1(e)}
                                    className="form-button"
                                    onClick={handleFileUpload1}
                                >
                                    <DragAudioIcon/>
                                    <p
                                        onDragStart={(e) => dragStartHandler1(e)}
                                        onDragLeave={(e) => dragLeaveHandler1(e)}
                                        onDragOver={(e) => dragStartHandler1(e)}
                                        onDrop={(e) => onDropHandler1(e)}
                                    >
                                        Перетащите файл сюда или <a>выберите файл</a>
                                    </p>
                                </div>

                                <input
                                    id="fileupload"
                                    type="file"
                                    name="fileupload"
                                    ref={fileInputRef1}
                                    style={{display: "none"}}
                                    onChange={handleFileChange1}
                                    multiple={true}
                                />
                            </div>
                        }
                        <div className="uploaded-files">
                            <ul className="uploaded-files-list">
                                {fileNames1.map((fileName, index) => (
                                    <li key={index}>
                                        <span className="js-remove-file" onClick={() => handleFileRemove1(index)}>
                                            <CloseIcon/>
                                        </span>
                                        <div className="file-name">
                                            <span>{fileName}</span>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>


                <div className="btns-box aside-btns">
                    <div className="col sub-col">
                        <p className="p-icon info-icon">После отправки ответа вы не сможете его редактировать.
                            <span className="icon">
                                   <InfoSmallerIcon/>
                        </span>
                        </p>
                    </div>
                    <div className="col btns-col">
                        <button type="submit" className="btn order2-desktop"><span>Добавить ответ</span></button>
                        <button type="button" className="btn secondary"><span>Отменить</span></button>
                    </div>
                </div>
            </form>
        </div>
    );
};

